module.exports = __webpack_public_path__ + "img/thumbnail_Okapi_j_normal.27306669.png";